// extracted by mini-css-extract-plugin
export default {"registrationWrapper":"Registration_registrationWrapper__UInbz","registrationButtons":"Registration_registrationButtons__iQydc"};